import { IGlobalPartner } from '../../../models/globalPartner'
import { GlobalPartnerTypes } from '../../../models/globalPartnerTypes'
import { IGlobalPartnerForm } from '../models/globalPartnerForm'

interface IMapGlobalPartnerToForm {
  globalPartner?: IGlobalPartner
  globalPartnerType: GlobalPartnerTypes
}
export const mapGlobalPartnerToForm = ({
  globalPartner,
  globalPartnerType,
}: IMapGlobalPartnerToForm): IGlobalPartnerForm => ({
  globalPartnerId: globalPartner?.GlobalPartnerId || '',
  globalPartnerName: globalPartner?.GlobalPartnerName || '',
  pbm: globalPartner?.PBM?.split(',') || [''],
  managers: globalPartner?.Managers?.split(',') || [''],
  rtm: globalPartnerType,
  enabledOfferings: globalPartner?.EnabledOfferings?.replace(/[[\]]/g, '').split(',') || [],
  isIts: globalPartner?.IsITS || 0,
  isReflectOnDashboards: globalPartner?.IsReflectOnDashboards || 0,
  offeringsState: [],
  executiveSummary: globalPartner?.ExecutiveSummary || '',
})
